export const MUST_NOT_BE_EMPTY_ERROR = 'Must not be empty';
export const MUST_BE_LONGER_THAN_3_CHARACTERS_ERROR = 'Must be longer than 3 characters';
export const OPTION_MUST_BE_SELECTED_ERROR = 'An option must be selected';
export const MIN_MAX_NUMBER_ERROR = 'Number must be between 9 and 11 digits';
export const MIN_MAX_IRISH_NUMBER_ERROR = 'Number must be between 7 and 9 digits';
export const WEBLINK_MUST_BE_PROVIDED_ERROR = 'Weblink must be provided';
export const ONLINE_STORE_MUST_BE_PROVIDED_ERROR = 'At least one online store must be provided';
export const MUST_BE_TICKED_ERROR = 'Must be ticked';
export const MUST_SELECT_YES_NO_ERROR = 'Must select yes or no';
export const MUST_SELECT_ONE_ERROR = 'Must select one';
export const MUST_SELECT_AT_LEAST_ONE_ERROR = 'Must select at least one';
export const MUST_UPLOAD_AT_LEAST_ONE_FILE_ERROR = 'Must upload at least one file';
export const UPLOAD_IN_PROGRESS_ERROR =
  'Files are currently being uploaded please wait for them to finish';
export const ALREADY_EXISTS_ERROR = 'Already exists';
export const MUST_NOT_EXCEED_250_ERROR = 'Must not exceed 250 characters.';
export const MUST_NOT_EXCEED_500_ERROR = 'Must not exceed 500 characters.';
export const ONLINE_STORE_ALREADY_EXISTS_ERROR = 'This store already exists';

export const COMPANY_NAME_COPY = 'Company name';
export const ENTER_ADDRESS_MANUALLY_COPY = 'Enter address manually';
export const PHONE_NUMBER_COPY = 'Your phone number';
export const INSTAGRAM_COPY = 'Instagram';
export const OTHER_SOCIAL_MEDIA_COPY = 'Other social media';
export const HOW_DID_YOU_HEAR_ABOUT_US_COPY = 'How did you hear about us?';
export const DELETE_SOCIAL_MEDIA_ARIA_LABEL = 'Delete social media';

export const ADD_STORE_COPY = 'Add store';

export const ID_CHECK_COPY =
  'We require a valid passport or driving license and a recent bank statement as part of our business checks. Please confirm you are able to provide these should your application be successful.';

export const HOW_SOON_START_SELLING_COPY = 'How soon will you be ready to start selling?';
export const ADD_MORE_SOCIAL_MEDIA_COPY = 'Add one more';
export const DELIVER_AREAS_UK_COPY = 'Can you deliver your products anywhere in the UK mainland?';
export const DELIVER_AREAS_SELF_DELIVERY_COPY = 'Do you deliver your products yourself?';
export const DELIVER_AREAS_AREAS_COPY = 'Which areas can you deliver your products to?';

export const REQUIRED_CERTIFICATION_COPY =
  'Please confirm you have the correct certification/documentation in place in order to sell your products. This could include but is not limited to product safety testing certificates, IP rights, or proof of sourcing.';

export const YOUR_WEBSITE_LABEL_COPY = 'Your website';
export const YOUR_WEBSITE_DESCRIPTION_COPY =
  'If you don’t have a website, feel free to include a URL which will help us to learn more about your business, for example a blog, an about you page';
export const PIPELINE_PLANS_PROVIDED_COPY =
  'Do you have any plans in the pipeline to develop your business or product range further?';
export const PIPELINE_PLANS_DETAILS_COPY = 'Briefly outline your development plans';

export const APPLICATION_SUCCESSFULLY_SUBMITTED =
  'Your application has been successfully submitted.';

export const SOMETHING_WENT_WRONG_COPY = 'Something went wrong!';

export const PACKAGING_UPLOAD_LABEL_COPY = 'Pictures/video of your packaging';
export const PACKAGING_UPLOAD_DESCRIPTION_COPY =
  'Include pictures of materials, packaging fillers, printed branding/inserts/info etc';
